import { BaseModel } from "./BaseModel";

export class Constants extends BaseModel {
  schema = "/constants";
  constructor(params = {}) {
    return super(params, "/constants");
  }
}
